import configEnv from '../config/config';

export default (relativePath: string) => {
  return `${configEnv.intranetBaseUrl}${relativePath}`;
};
